import ImageAnnotationModal from './ImageAnnotationModal';
import ImageResolutionSpecificationModal from './ImageResolutionSpecificationModal';

import ImageInsertionModal from './ImageInsertionModal';
import React, { createContext, useCallback, useContext } from 'react';

import Modal from '@material-ui/core/Modal';
import { FigureModalArgs } from './FigureInteractionProvider';
import { FigureInteractionEventDispatch } from './Contexts';
const modalMap = {
  imageAnnotation:ImageAnnotationModal,
  setImageResolution:ImageResolutionSpecificationModal,

  insertImage:ImageInsertionModal,

}

export const ModalDispatch = createContext();


export default function FigureEditorModal(){

  const modalArgs = useContext(FigureModalArgs);
  const onFigureInteractionEvent = useContext(FigureInteractionEventDispatch);

  const onClose = useCallback(() => onFigureInteractionEvent({type:"closeModal"}),[onFigureInteractionEvent]);


  if( !modalArgs ){
    return null;
  }


  let { modal } = modalArgs;

  let ele = modalMap[modal];
  if(!ele){
    throw Error(`No modal registered for '${modal}'.`);
  }

  let modalProps = {
    ...modalArgs,
    onClose
  }

  let content = React.createElement(ele,modalProps);


  


  return (

    <div onClick={e => {

      //alert("HELLO");

      onClose();

    }} style={{

      width:'100%', 
        height:'100%',
      top:0,
      left:0,
      position:'fixed', 
      minWidth:0,

      zIndex:100000,
      background:'rgba(0,0,0,0.4)',


    }}>

    <div onClick={e => {

      alert("HELLO");

      onClose();

    }} style={{

        width:'90%', left:'5%',
        height:'90%', top:'5%',
        
        //minWidth:0,
        //outline:'10000px solid rgba(0,0,0,0.4)',

        borderRadius:4,
        position:'relative', 
        zIndex:100000,
        
        
      }} 
        open={true} 
        onClose={onClose}>


        <div
          onMouseUp={onMouseUp}
          onMouseDown={e => e.stopPropagation()}
          onClick={e => e.stopPropagation()}
          style={{
            background:'white', 
            borderRadius:4,
            height:'100%',
            position:'relative',
            border:'1px solid #ccc',
            minWidth:0,
          }}>
          {content}
        </div>
      </div>
    </div>
  )


}

function onMouseUp(){
  /*
   if e.stopPropagation() is called in the modal here
   then it will stop any of the window listeners and
   break other functionality.
   Specifically, annotation interaction, 
   dragging boxes around breaks if you 
   stop propagation, because they 
   rely on window mouseup listeners.
  */
}
